import getConfig from "./config";
import {loadCSS} from "./helpers";

const config = getConfig();

const updateMaps = (maps) => {
    maps.forEach((mapplic) => {
        const info = JSON.parse(mapplic.getAttribute("data-json"));
        const markers = [
            ...mapplic.shadowRoot.querySelectorAll(".mapplic-marker"),
        ];
        markers.forEach((marker) => {
            const index = markers.indexOf(marker);
            const location =
                -1 < index ? (info.locations[index] ?? null) : null;
            const link = location?.link;
            const target = location?.target ?? "_self";
            const desc = location?.desc;

            if (desc) {
                const temp = document.createElement("div");
                temp.innerHTML = desc;
                marker.setAttribute("title", temp.textContent);
            }

            if (link) {
                marker.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    window.open(link, target);
                });
            }
        });
    });
};
const setupMapplic = () => {
    const mapplicStylesheet = config?.assets?.css?.mapplic;

    if (!mapplicStylesheet) {
        return;
    }

    const maps = [...document.getElementsByTagName("mapplic-map")];
    maps.forEach((mapplic) => {
        const shadow =
            mapplic.shadowRoot || mapplic.attachShadow({mode: "open"});
        loadCSS(mapplicStylesheet, shadow);
    });

    if (0 < maps.length) {
        if ("complete" === document.readyState) {
            updateMaps(maps);
        } else {
            window.addEventListener("load", () => {
                updateMaps(maps);
            });
        }
    }
};

export {setupMapplic};
